"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-env browser */
var pulse_cookie_1 = require("./pulse-cookie");
function crossReference(urls) {
    if (Array.isArray(urls) && urls.length > 0) {
        var url = urls[0];
        return fetch("https://".concat(url, "/api/v1/pulse"), {
            method: 'GET',
            credentials: 'include'
        })
            .then(function (result) { return result.json(); }) // New promise
            .then(function (response) {
            var pulse2data = (response || {}).pulse2data;
            if (pulse2data) {
                try {
                    var serverData = (0, pulse_cookie_1.parsePulseCookies)(pulse2data);
                    if (serverData.environmentId) {
                        var environmentId = (0, pulse_cookie_1.parsePulseCookies)().environmentId;
                        (0, pulse_cookie_1.cacheOldEnvironmentId)(environmentId);
                        (0, pulse_cookie_1.serializePulseCookie)(serverData);
                        return Promise.resolve(pulse2data);
                    }
                    return crossReference(urls.slice(1));
                }
                catch (e) {
                    return crossReference(urls.slice(1));
                }
            }
            return crossReference(urls.slice(1));
        })
            .catch(function () { return crossReference(urls.slice(1)); });
    }
    return Promise.resolve();
}
exports.default = crossReference;
//# sourceMappingURL=crossReference.js.map